var $ = require('jquery');
var websiteData = require('diy/util/websiteData');
var l10n = require('diy/util/l10n');

module.exports = {
    toggleState: function() {
        var defer = Q.defer();

        $.ajax({
            type: 'post',
            dataType: 'json',
            accepts: {
                text: 'application/json'
            },
            contentType: 'application/vnd.oneandone.diy.website.switch.staging+json',
            url: '/rest/websites/' + websiteData.getId() + '/staging/',
            success: function(data) {
                defer.resolve(data.state);
            },
            error: function(response) {
                response.skipBlackError = true;

                var msgEl = $('<div></div>');
                msgEl.diy_messageDialog({
                    zIndex: diy.editor.getNewTopZIndex()
                });
                msgEl.diy_messageDialog('showErrorMessage', l10n.getString('timeout'));
                defer.reject();
            }
        });

        return defer.promise;
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/maintenanceMode/rest.js
 ** module id = 670
 ** module chunks = 0
 **/